import React, { useEffect, useState } from 'react'
import Button from '../../../Components/Buttons/Button'
import Input from '../../../Components/Input/Input'
import useTime from '../../../Helpers/CustomHooks/useTime'
import { formatMsToHHMMSS } from '../../../Helpers/Misc'
import { RecorderOptionsEl } from '../Elements'
import VideoRecordStore from '../Stores/VideoRecordStore'

function RecorderOptions({ maxDuration }) {
  const {
    recordingState,
    cameras,
    activeCamera,
    setActiveCamera,
    mics,
    activeMic,
    setActiveMic,
    startRecording,
    stopRecording,
  } = VideoRecordStore.useContainer()

  const [startTime, setStartTime] = useState(null)
  const now = useTime(1000)

  useEffect(() => {
    if (startTime && now - startTime > maxDuration) stopRecording()
    // if () console.log(now - startTime, maxDuration);
  }, [now, startTime, stopRecording, maxDuration])

  return (
    <RecorderOptionsEl state={recordingState}>
      {recordingState === 'NOT RECORDED' ? (
        <>
          <Input
            type='select'
            value={{
              label: activeCamera?.label || 'Select a camera',
              value: activeCamera,
            }}
            options={cameras.map((camera, i) => ({
              value: camera,
              label: camera.label || `Camera ${i + 1}`,
            }))}
            placeholder='Camera'
            onChange={({ value }) => setActiveCamera(value)}
          />
          <Input
            type='select'
            value={{ label: activeMic.label, value: activeMic }}
            options={mics.map((mic, i) => ({
              value: mic,
              label: mic.label || `Microphone ${i + 1}`,
            }))}
            onChange={({ value }) => setActiveMic(value)}
          />
          <Button
            name={'Record'}
            type='primary'
            onClick={() => {
              startRecording()
              setStartTime(now)
            }}
          />
        </>
      ) : (
        recordingState === 'RECORDING' && (
          <>
            <div className='timer'>
              <b>Time:</b> {formatMsToHHMMSS(now - startTime, false)}
            </div>
            <Button
              name={'Stop Recording'}
              type={'primary'}
              onClick={() => stopRecording()}
            />
          </>
        )
      )}
    </RecorderOptionsEl>
  )
}

export default RecorderOptions
